/** Visual style of an announcement shown in the stork-app top bar. */
export enum AnnouncementType {
    Info = 'info',
    News = 'news',
    Event = 'event',
    Warning = 'warning',
    Critical = 'critical',
}

/**
 * Well-known values for `frequencyMinutes`: how long after a user discards an announcement
 * it shows up again for that user.
 */
export enum AnnouncementFrequency {
    /** Shows up again on the next app load. */
    EveryVisit = 0,
    Daily = 1440,
    Weekly = 10080,
    /** Once discarded it never comes back for that user. */
    Once = -1,
}

/**
 * Who an announcement is meant for. Announcements stored before this field existed have none and
 * are read as `User`.
 */
export enum AnnouncementTarget {
    /** stork-app users, on the top bar. */
    User = 'user',
    /** Drivers, in the driver app. */
    Driver = 'driver',
}
